import { DoorCrewSeat } from './types';

export interface TurfSeatGroup {
  turfId: number | null;
  turf: DoorCrewSeat['turf'];
  seats: DoorCrewSeat[];
}

export function getSeatTurfId(seat: DoorCrewSeat): number | null {
  if (!seat?.turf) {
    return null;
  }
  if (typeof seat.turf === 'object') {
    if ('id' in seat.turf && seat.turf.id !== undefined) {
      return seat.turf.id;
    }
    return seat.turf._raw_id ?? null;
  }
  return seat.turf;
}

export function groupSeatsByTurf(seats: DoorCrewSeat[]): TurfSeatGroup[] {
  const groups: TurfSeatGroup[] = [];
  const groupsByTurfId = new Map<number | null, TurfSeatGroup>();

  for (const seat of seats) {
    const turfId = getSeatTurfId(seat);
    let group = groupsByTurfId.get(turfId);

    if (!group) {
      group = { turfId, turf: seat.turf, seats: [] };
      groupsByTurfId.set(turfId, group);
      groups.push(group);
    }

    group.seats.push(seat);
  }

  return groups;
}
